import "swiper/css";

const CustomSlider = ({
	items,
	createSlider,
	lazy = true,
	customClass = "",
}) => {
	if (!items && !Array.isArray(items)) return null;

	createSlider();

	return (
		<div className={`swiper ${customClass}`}>
			<div className="custom-loader"></div>
			<div className="swiper-wrapper">
				{items.map((item, index) => (
					<div key={index} className="swiper-slide">
						{item}
						{lazy && <div className="swiper-lazy-preloader"></div>}
					</div>
				))}
			</div>
		</div>
	);
};

export default CustomSlider;
